import React, { useMemo } from 'react';
import { Control } from 'react-hook-form';
import { FilterState } from '@/types/filter';
import { FilterSection } from '../../FilterSection/FilterSection';
import { SectionConfig } from '../filters.config';
import styles from './StandardView.module.css';

const RECOMMENDATIONS_SPLIT_INDEX = 2;

interface StandardViewProps {
  config: SectionConfig;
  control: Control<FilterState>;
}

export const StandardView: React.FC<StandardViewProps> = ({ config, control }) => {
  const splitIndex =
    config.id === 'recommendations' ? RECOMMENDATIONS_SPLIT_INDEX : Math.ceil(config.filterKeys.length / 2);
  const leftKeys = useMemo(() => config.filterKeys.slice(0, splitIndex), [config.filterKeys, splitIndex]);
  const rightKeys = useMemo(() => config.filterKeys.slice(splitIndex), [config.filterKeys, splitIndex]);

  return (
    <div className={styles.splitLayout}>
      <div className={styles.column}>
        <FilterSection defaultStateOpen={true} filterKeys={leftKeys} formControl={control} useFloatingLabel={true} />
      </div>

      <div className={`${styles.column} ${styles.rightColumnWrapper}`}>
        <FilterSection defaultStateOpen={true} filterKeys={rightKeys} formControl={control} useFloatingLabel={true} />
      </div>
    </div>
  );
};
